import React from 'react';

export const FacebookIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8203 0.212402C12.0132 0.212402 0.820312 11.4053 0.820312 25.2124C0.820312 39.0195 12.0132 50.2124 25.8203 50.2124C39.6274 50.2124 50.8203 39.0195 50.8203 25.2124C50.8203 11.4053 39.6274 0.212402 25.8203 0.212402ZM27.6784 27.6737H31.1874L31.6455 23.2589H27.6784V20.6558C27.6784 19.6771 28.324 19.448 28.7821 19.448H31.5778V15.1529L27.7201 15.1373C23.4406 15.1373 22.4723 18.3443 22.4723 20.3851V23.2485H19.9941V27.6737H22.4723V38.9763H27.6784V27.6737Z"
      fill="#F1F2F3"
      fillOpacity="0.31"
    />
  </svg>
);
